import { Controller } from "@hotwired/stimulus"

// Live preview for manual sales tax (matches ManualSalesTaxCalculatorService).
export default class extends Controller {
  static targets = ["amount", "rate", "preview"]
  static values  = { balanceCents: Number }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasPreviewTarget) return

    const raw = this.amountTarget.value
    const dollars = parseFloat(raw)
    const rateRaw = this.rateTarget.value.trim()
    const rate = rateRaw === "" ? 0 : parseFloat(rateRaw)

    const inclusiveRadio = this.element.querySelector(
      'input[name="manual_sales_tax_inclusive"][value="1"]'
    )
    const inclusive = inclusiveRadio && inclusiveRadio.checked

    const fmt = (cents) => `$${(cents / 100).toFixed(2)}`

    const setPreview = (text) => {
      const t = (text || "").trim()
      this.previewTarget.textContent = t
      this.previewTarget.hidden = t.length === 0
    }

    if (isNaN(dollars) || dollars <= 0) {
      setPreview("")
      return
    }

    const totalCents    = Math.round(dollars * 100)
    const balanceCents  = this.balanceCentsValue || 0

    if (isNaN(rate) || rate <= 0) {
      setPreview("")
      return
    }

    let taxCents, principalCents, collectedCents

    if (inclusive) {
      // Admin enters total cash collected; tax is extracted from within that amount.
      // Only the pre-tax principal is credited against the lesson balance.
      principalCents = Math.round(totalCents / (1 + rate / 100))
      taxCents       = totalCents - principalCents
      if (taxCents < 0) taxCents = 0
      collectedCents = totalCents

      const remainingCents = balanceCents - principalCents
      const remainingStr   = remainingCents === 0
        ? "Balance cleared"
        : remainingCents > 0
          ? `Remaining balance: ${fmt(remainingCents)}`
          : `Credit: ${fmt(Math.abs(remainingCents))}`

      setPreview(
        `Sales tax: ${fmt(taxCents)} (inclusive) · Applied to balance: ${fmt(principalCents)} · ${remainingStr}`
      )
    } else {
      // Student pays totalCents (pre-tax); tax is added on top and collected separately.
      principalCents = totalCents
      taxCents       = Math.round((principalCents * rate) / 100)
      if (taxCents < 0) taxCents = 0
      collectedCents = principalCents + taxCents

      const remainingCents = balanceCents - principalCents
      const remainingStr   = remainingCents === 0
        ? "Balance cleared"
        : remainingCents > 0
          ? `Remaining balance: ${fmt(remainingCents)}`
          : `Credit: ${fmt(Math.abs(remainingCents))}`

      setPreview(
        `Sales tax: ${fmt(taxCents)} (added on top) · You collect: ${fmt(collectedCents)} · Applied to balance: ${fmt(principalCents)} · ${remainingStr}`
      )
    }
  }
}
